import React from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import ProblemsSection from './ProblemsSection';
import SolutionsSection from './SolutionsSection';
import ComparisonSection from './ComparisonSection';
import TestimonialsSection from './TestimonialsSection';
import ProcessSection from './ProcessSection';
import GallerySection from './GallerySection';
import CaseStudySection from './CaseStudySection';
import FAQSection from './FAQSection';
import ContactSection from './ContactSection';
import Footer from './Footer';
import { Toaster } from './ui/sonner';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ProblemsSection />
        <SolutionsSection />
        <ComparisonSection />
        {/* <TestimonialsSection /> */}
        <CaseStudySection />
        <ProcessSection />
        <GallerySection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

export default LandingPage;